var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from 'react';
import { FormActionTypes } from '../types/form/actionTypes';
/**
 * Initial form state
 */
var initialState = {
    currentStep: 1,
    entryMethod: 'rego',
    regoDetails: {
        rego: '',
        state: '',
    },
    vehicleDetails: null,
    manualLookupDetails: null,
    exclusionStatus: null,
    previousSession: null
};
// Create context with proper typing
var FormContext = createContext(undefined);
/**
 * Form reducer with type-safe action handling
 */
function formReducer(state, action) {
    var _a, _b;
    switch (action.type) {
        case FormActionTypes.SET_STEP: {
            var step = action.payload;
            return __assign(__assign({}, state), { currentStep: step });
        }
        case FormActionTypes.SET_REGO_DETAILS: {
            var details = action.payload;
            return __assign(__assign({}, state), { regoDetails: details });
        }
        case FormActionTypes.SET_VEHICLE_DETAILS: {
            var details = action.payload;
            return __assign(__assign({}, state), { vehicleDetails: details });
        }
        case FormActionTypes.SET_MANUAL_LOOKUP_DETAILS: {
            var details = action.payload;
            return __assign(__assign({}, state), { manualLookupDetails: details });
        }
        case FormActionTypes.SET_ENTRY_METHOD: {
            var method = action.payload;
            return __assign(__assign({}, state), { entryMethod: method });
        }
        case FormActionTypes.SET_EXCLUSION_STATUS: {
            var status_1 = action.payload;
            return __assign(__assign({}, state), { exclusionStatus: status_1 });
        }
        case FormActionTypes.SET_PREVIOUS_SESSION: {
            var session = action.payload;
            if (!session) {
                return state;
            }
            return __assign(__assign({}, state), { previousSession: session, regoDetails: {
                    rego: ((_a = session.vehicleInfo) === null || _a === void 0 ? void 0 : _a.registrationNumber) || '',
                    state: ((_b = session.vehicleInfo) === null || _b === void 0 ? void 0 : _b.registrationState) || ''
                }, vehicleDetails: session.vehicleInfo || null, currentStep: session.currentStep || 1 });
        }
        case FormActionTypes.RESET_FORM:
            return initialState;
        default:
            return state;
    }
}
/**
 * Form provider component
 */
export var FormProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(formReducer, initialState), state = _b[0], dispatch = _b[1];
    return (_jsx(FormContext.Provider, { value: { state: state, dispatch: dispatch }, children: children }));
};
/**
 * Custom hook for using the form context
 */
export var useForm = function () {
    var context = useContext(FormContext);
    if (context === undefined) {
        throw new Error('useForm must be used within a FormProvider');
    }
    return context;
};
export { FormActionTypes };
